import { generateTheme } from "@catchoftheday/cg-components";

const cartTheme = generateTheme();

cartTheme.textStyles.label.fontWeight = cartTheme.fontWeights.light;
cartTheme.textStyles.text.fontWeight = cartTheme.fontWeights.light;

export default cartTheme;
